<template>
  <div>
    <NoteList v-if="curPage=='NoteList'" @changePage="changePage"/>
    <NoteDetail v-else :detail="detail" @changePage="changePage"/>
  </div>
</template>

<script>
import NoteList from './components/noteList.vue'
import NoteDetail from './components/noteDetail.vue'
export default {
   data(){
      return{
        detail:{},
        curPage:'NoteList'
      }
   },
   components:{
      NoteList,
      NoteDetail
   },
   methods:{
      changePage(payLoad){
        console.log(payLoad,'payLoad');
        const {query, page} = payLoad
        this.detail=query
        this.curPage=page
      }
   },
}
</script>
<style lang="scss" scoped>

</style>